import type { CollectionItem } from './types'

function normalizeSearchText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{M}+/gu, '')
    .toLowerCase()
    .replace(/[\u2018\u2019`\u00b4]/g, "'")
    .replace(/'s\b/g, 's')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function matchesCollectionSearch(
  item: CollectionItem,
  query: string,
): boolean {
  const terms = normalizeSearchText(query).split(' ').filter(Boolean)

  if (!terms.length) {
    return true
  }

  const searchableText = normalizeSearchText(
    [
      item.name,
      item.setName,
      item.setCode,
      item.collectorNumber,
      item.rarity,
      item.category,
      item.condition,
      Array.isArray(item.colors) ? item.colors.join(' ') : '',
      item.notes,
      item.typeLine ?? '',
      item.rulesText ?? '',
      item.sport ?? '',
      item.manufacturer ?? '',
      item.releaseName ?? '',
      item.releaseYear ?? '',
      item.parallelName ?? '',
      item.numberedTo === undefined ? '' : String(item.numberedTo),
      Array.isArray(item.attributes) ? item.attributes.join(' ') : '',
      item.gradingCompany ?? '',
      item.grade ?? '',
      item.certificationNumber ?? '',
      item.gradeQualifier ?? '',
      item.autographGrade ?? '',
      Array.isArray(item.subtypes) ? item.subtypes.join(' ') : '',
      Array.isArray(item.attacks)
        ? item.attacks.map((attack) => `${attack.name} ${attack.text}`).join(' ')
        : '',
      Array.isArray(item.abilities)
        ? item.abilities
            .map((ability) => `${ability.name} ${ability.text}`)
            .join(' ')
        : '',
    ].join(' '),
  )

  return terms.every((term) => searchableText.includes(term))
}
